import { render, staticRenderFns } from "./kecamatan.vue?vue&type=template&id=96a314e2&"
import script from "./kecamatan.vue?vue&type=script&lang=js&"
export * from "./kecamatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports